// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-btn[data-v-43350688]:hover{text-decoration:none;color:#70bab0!important}.v-slide-group__content[data-v-43350688]{text-align:left;display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
